import React, { useContext } from 'react';
import { TripodContext, TripodContextValue } from '@moment/context/TripodContext.tsx';
import { TripodLivePreview } from '@moment/layouts/TripodLivePreview/LivePreview.tsx';

interface TabbedPageRendererProps {
  pageId: string;
  pageDataMap: Record<string, any>;
}

/**
 * This component acts as a bridge between the TabContainerLayout's context
 * and the TripodLivePreview's props. It finds the correct page data from
 * the `pageDataMap` and passes it down.
 */
export const TabbedPageRenderer: React.FC<TabbedPageRendererProps> = ({ pageId, pageDataMap }) => {
  const pageData = pageDataMap[pageId];
  return <TripodLivePreview pageData={pageData} pageId={pageId} />;
};
